import React from 'react';
interface VideoContext {
  isVideoMandatory: boolean;
}
export default React.createContext<boolean>(null as any);
